import {ExportOutlined} from '@ant-design/icons';
import {Button, Flex, Table, TableProps, Tag, Tooltip, Typography} from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import {ApiQuery} from '../../../gen/api';
import {AdminPalletOrderList} from '../../../gen/api/models';
import {useScreenInfo} from '../../../ResponsiveGate';

const {Title} = Typography;

export const PalletOrderListPage: React.FC = () => {
    const {screenMap} = useScreenInfo();
    const navigate = useNavigate();

    const [pallets, setPallets] = React.useState<AdminPalletOrderList[]>();

    const palletOrdersQuery = ApiQuery.useAdminGetAllPalletsQuery({
        onSuccess(data) {
            setPallets(data.items);
        },
        refetchOnMount: 'always',
    });

    const columns: TableProps<AdminPalletOrderList>['columns'] = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (name, pallet) => (
                <Flex align={'center'}>
                    <a onClick={() => navigate(`/pallet-orders/${pallet.id}`)}>{name}</a>
                    <Tooltip title={`Open order's external link`}>
                        <Button
                            size={'small'}
                            type="link"
                            onClick={() => window.open(pallet.orderLink, '_blank')}
                            icon={<ExportOutlined />}
                        />
                    </Tooltip>
                </Flex>
            ),
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            render: (text) => <>${text}</>,
        },
        {
            title: 'Products Total/Created',
            dataIndex: 'items',
            key: 'items',
            render: (items, pallet) => {
                const tagColor = items === pallet.productItems + pallet.junkItems ? 'green' : undefined;
                return (
                    <Tag color={tagColor}>
                        {items}/{pallet.productItems}
                    </Tag>
                );
            },
        },
        {
            title: 'Junk Products',
            dataIndex: 'junkItems',
            key: 'junkItems',
        },
        {
            title: 'Order Date',
            dataIndex: 'orderDate',
            key: 'orderDate',
            render: (date) => dayjs(date).format('MM/DD/YYYY hh:mm A'),
        },
    ];

    return (
        <div>
            <Flex
                justify="space-between"
                align="center"
                style={{marginBottom: 16}}
            >
                <Title
                    level={screenMap.lg ? 3 : 5}
                    style={{margin: '0 10px 0 0'}}
                >
                    Pallet Orders
                </Title>
                <Button
                    type="primary"
                    onClick={() => {
                        navigate('/pallet-orders/new');
                    }}
                >
                    Add Order
                </Button>
            </Flex>

            <Table<AdminPalletOrderList>
                rowKey={(record) => record.id}
                columns={columns}
                dataSource={pallets}
                loading={palletOrdersQuery.isLoading}
                scroll={{x: 'max-content'}}
                pagination={false}
                size={'small'}
            />
        </div>
    );
};
